export const persons = [
        {
            name: "mgr Paulina Romanowska",
            phone: ["668 992 909"],
            email: "paulina.rmnwsk@gmail.com",
            role: "Osoba zaufania"
        },
        {
            name: "mgr Anna Ślęzak",
            phone: ["792 830 840"],
            email: "ania.m.slezak@gmail.com",
            role: "Osoba zaufania"
        },
        {
            name: "ks. mgr Rafał Kowalski",
            address: "ul. Św. Barbary 41, 42-226 Częstochowa",
            phone: ["697 133 921"],
            email: "kowalski.delegat@gmail.com",
            role: "Delegat biskupa diecezjalnego"
        },
        {
            name: "o. Jan Mazur SJ",
            address: "ul. Św. Kingi 74/84, 42-226 Częstochowa",
            phone: ["34/324 40 19", "797 907 678"],
            email: "jan.mazur@jezuici.pl",
            role: "Duszpasterz do pomocy duchowej ofiarom, ich rodzinom oraz wspólnotom lokalnym"
        },
        {
            name: "ks. prał. dr Bernard Kozłowski",
            address: "al. Jana Pawła II nr 82, 42-200 Częstochowa",
            phone: ["34/361 31 38", "603 767 299"],
            email: "ks.b.kozłowski@archiczest.pl",
            role: "Kurator dla duchownych"
        },
    ]

export const content = ""